import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Field } from 'src/app/models_new/classes/field';
import { FieldType } from 'src/app/models_new/types/field-type';
import {
  IContactInfo,
  PublicApiService,
} from 'src/app/services/api/public-api.service';
import { environment } from 'src/environments/environment';

enum FormControlStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
}

@Component({
  selector: 'app-quote-form-dialog',
  templateUrl: './quote-form-dialog.component.html',
  styleUrls: ['./quote-form-dialog.component.scss'],
})
export class QuoteFormDialogComponent implements OnInit {
  lastActionCooldown: number;
  contactInfo: IContactInfo;
  simulationId: string;
  requestStatus: null | 'succeed' | 'failed';
  reCaptchaCheck!: UntypedFormGroup;
  siteKey = environment.reCaptchaSiteKey;

  fields = [
    new Field(
      FieldType.TEXT,
      true,
      '',
      [Validators.required, Validators.email],
      null,
      [],
      null,
      { name: 'email', label: 'Email address' },
      'email'
    ),
    new Field(
      FieldType.NUMBER,
      false,
      '',
      null,
      null,
      [],
      null,
      {
        name: 'phone',
        label: 'Phone',
      },
      'phone'
    ),
    new Field(
      FieldType.TEXTAREA,
      false,
      '',
      null,
      null,
      [],
      null,
      {
        name: 'details',
        label: 'Additional info',
        hint: 'Please add if you have any additional information you think is relevant for the solution provider',
      },
      'details'
    ),
  ];

  constructor(
    public dialogRef: MatDialogRef<QuoteFormDialogComponent>,
    private publicApiService: PublicApiService,
    public formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data?.data) {
      this.lastActionCooldown = data.data.lastActionCooldown;
      this.simulationId = data.data.simulationId;
    }
  }

  ngOnInit(): void {
    this.reCaptchaCheck = this.formBuilder.group({
      recaptcha: ['', Validators.required],
    });
  }

  sendRequest() {
    if (
      this.fields[0].formControl.status === FormControlStatus.VALID &&
      Date.now() - this.lastActionCooldown > 5000
    ) {
      this.contactInfo = {
        email: this.fields[0].formControl.value,
        phone: this.fields[1].formControl.value,
        details: this.fields[2].formControl.value,
      };
      this.publicApiService
        .requestSolutionQuote(this.contactInfo, this.simulationId)
        .subscribe(
          (res) => (this.requestStatus = res == 'sent' ? 'succeed' : 'failed')
        );
    }
  }

  close() {
    this.dialogRef.close(null);
  }
}
